"use strict";

exports.__esModule = true;
exports.ActivitiesChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _ActivitiesChartElement = _interopRequireDefault(require("./ActivitiesChartElement"));
var _ActivitiesChartFields = _interopRequireDefault(require("./ActivitiesChartFields"));
var _ActivitiesChartThumbnail = _interopRequireDefault(require("./ActivitiesChartThumbnail"));
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ActivitiesChart = exports.ActivitiesChart = {
  name: "ActivitiesChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ActivitiesChart.label",
    defaultMessage: "Activities Chart"
  }),
  icon: "th-list",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "ActivitiesChart",
      props: Object.assign({
        width: 512,
        height: 512,
        aggregations: [],
        filters: [],
        hideXAxis: false,
        hideYAxis: false,
        hideYUnits: false,
        showLegends: true,
        showTooltip: true,
        tooltipSort: "desc"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_ActivitiesChartElement["default"], function () {
      return {
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ActivitiesChartWidget.card.title",
          defaultMessage: "Activities"
        })
      };
    }),
    Fields: _ActivitiesChartFields["default"],
    Thumbnail: _ActivitiesChartThumbnail["default"]
  }
};